import { GridCustomHeaderCellProps } from '@progress/kendo-react-grid';
import { HeaderThElement } from '@progress/kendo-react-data-tools';

export const RightAlignHeaderCell = (props: GridCustomHeaderCellProps) => {
    return <HeaderThElement {...props.thProps} style={{ justifyContent: 'flex-end' }}>
        {props.children}
    </HeaderThElement>
};
